import { Component, Input } from '@angular/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { IAccordionPanel } from './models';

@Component({
  selector: 'ui-accordion',
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
  standalone: true,
  imports: [NzCollapseModule],
})
export class UIAccordion {
  @Input() panels!: IAccordionPanel[];
}
